import { GAME_TIME } from "./Timer";
import { levelsMap } from "./levelsData";

export const inverseTransform = (gameData) => {
  if (gameData.levelData.length === 0)
    return {
      level: 1,
      seconds: GAME_TIME,
      completed: false,
      stats: {
        time: [{ start: GAME_TIME, end: null, wasSkipped: false }],
        resets: 0,
        moves: [],
        playMoves: Array.from({ length: levelsMap.length }).fill(0),
        pastMoves: Array.from({ length: levelsMap.length }).fill([]),
      },
    };
  const levels = gameData.levelData.sort((a, b) => a.level - b.level);
  const currentTime =
    levels.length < levelsMap.length
      ? [
          {
            start: GAME_TIME - gameData.totalTime,
            end: null,
            wasSkipped: false,
          },
        ]
      : [];
  return {
    level: levels.length,
    seconds: levels[levels.length - 1].timeLeft,
    completed: levels[levels.length - 1].isLevelCleared,
    stats: {
      time: levels
        .map((level, levelIndex) => ({
          start: levelIndex === 0 ? GAME_TIME : GAME_TIME - level.startTime,
          end: level.timeLeft,
          wasSkipped: false,
        }))
        .concat(currentTime),
      resets: 0,
      pastMoves: Array.from({ length: levelsMap.length })
        .fill([])
        .map((pastMove, pastMoveIndex) =>
          pastMoveIndex < gameData.pastMoves.length
            ? gameData.pastMoves.slice(pastMoveIndex, pastMoveIndex + 1).concat(
                Array.from({
                  length: levels[pastMoveIndex].attempts - 2,
                }).fill({ main: 0, proc: 0, total: 0 })
              )
            : pastMove
        ),
      moves: levels.map((level) => ({
        movesArray: Array.from({ length: level.mainCommands })
          .fill("")
          .map((_, i) =>
            level.procInMain ? (i < level.procInMain ? "PROCEDURE" : "") : ""
          ),
        loopArray: Array.from({ length: level.procCommands }).fill(""),
      })),
      playMoves: levels
        .map((level) => level.attempts)
        .concat(
          Array.from({ length: levelsMap.length - levels.length }).fill(0)
        ),
    },
  };
};
